import React from 'react'
import R from 'ramda'
import {FormattedMessage} from 'react-intl'

import AreaRange from './AreaRange'
import Area from './Area'

class AreaField extends React.Component {
  constructor(props){
    super(props)
    this.state = props.areas
    this.onUpdateBinded = this.onUpdate.bind(this)
  }
  onUpdate(values){
    this.setState(values)
  }
  render(){
    const {areaUnit, options, onChange} = this.props
    const {min, max} = this.state
    const unitEntry = R.find(R.propEq('name', areaUnit), options.areaUnits)
    const unit = R.propOr('', 'name', unitEntry)
    return <div className="range-field-container area-range">
      <div className="range-field-values-container">
        <Area area={min} unit={unit}/>
        &nbsp;
        <FormattedMessage id="to" defaultMessage="to"/>
        &nbsp;
        {max == -1 ? <FormattedMessage id="Unlimited" defaultMessage="Unlimited"/> : <Area area={max} unit={unit}/>}
      </div>
      <AreaRange unit={unit} min={min} max={max} onChange={onChange} onUpdate={this.onUpdateBinded}/>
    </div>
  }
}

AreaField.propTypes = {
  areas: React.PropTypes.shape({
    min: React.PropTypes.number.isRequired,
    max: React.PropTypes.number.isRequired,
  }),
  areaUnit: React.PropTypes.string.isRequired,
  options: React.PropTypes.shape({
    areaUnits: React.PropTypes.array.isRequired,
  }).isRequired,
  onChange: React.PropTypes.func.isRequired,
}

export default AreaField



/** WEBPACK FOOTER **
 ** ./app/components/AreaField.jsx
 **/